import { makeStyles, Theme } from "@material-ui/core/styles"

const styles = makeStyles((theme: Theme) => ({
  title: {
    color: theme.palette.body.secondary,
    fontSize: "16px",
    fontWeight: 600
  },
  body: {
    color: theme.palette.body.dark,
    fontSize: "14px"
  },
  totalStyle: {
    color: theme.palette.body.greenLight100,
    fontSize: "64px",
    fontWeight: 500
  },
  headerWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 23px",
    borderBottom: "1px solid #F2F2F2"
  },
  totalWrapper: {
    alignItems: "center",
    justifyContent: "space-between",
    padding: "26px 50px"
  },
  listWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 23px",
    borderTop: "1px solid #F2F2F2"
  }
}))

export default styles
